<ng-template
  let-field="field"
  let-channel="channel"
  let-viewSource="viewSource"
  let-modeView="modeView"
  let-allowScalars="allowScalars"
  let-allowDiscrete="allowDiscrete"
  let-allowContinuous="allowContinuous"
  #dragAndDrop
>
  <mode-encoding-field-single
    *ngIf="isEncField(field)"
    (update)="fieldUpdated($event)"
    (remove)="removeField($event)"
    (removeSort)="removeSort($event)"
    (toggleDualAxis)="toggleDualAxis($event)"
    (getBinSize)="getBinSize($event)"
    [encoding]="encoding"
    [field]="field"
    [fieldFormatMap]="fieldFormatMap$ | async"
    [format]="format$ | async"
    [model]="model"
    [view]="modeView"
    [viewName]="viewSource"
    [vizToken]="vizToken$ | async"
    [chartType]="chartType"
    [binSizeToFieldMap]="binSizeToFieldMap$ | async"
    [allowScalars]="allowScalars"
    [allowAggregates]="true"
    [allowDiscrete]="allowDiscrete"
    [allowContinuous]="allowContinuous"
  ></mode-encoding-field-single>

  <mode-shared-axis-encoding
    *ngIf="isEncFieldGroup(field)"
    [channel]="channel"
    [isDraggable]="isDragging()"
    [fieldGroup]="field"
    [fields]="getGroupEncFields(field)"
    [fieldFormatMap]="fieldFormatMap$ | async"
    [format]="format$ | async"
    [encoding]="encoding"
    [model]="model"
    [vizToken]="vizToken$ | async"
    [queryToken]="queryToken$ | async"
    [view]="view$ | async"
    [chartService]="chartService"
    [chartType]="chartType"
    [binSizeToFieldMap]="binSizeToFieldMap$ | async"
    [dragField]="dragInfo"
    (dragStart)="onDragStart($event)"
    (dragEnd)="onDragEnd($event)"
    (fieldDragEnd)="onFieldDragEnd()"
    (fieldUpdated)="fieldUpdated($event)"
    (getBinSize)="getBinSize($event)"
    (remove)="removeField($event)"
  >
  </mode-shared-axis-encoding>
</ng-template>

<div class="encoding-zone-container">
  <div class="zone margin-bottom-medium">
    <mode-encoding-dropzone
      data-test="column-dropzone"
      [header]="'Columns (X)'"
      [channel]="'column'"
      [isDraggable]="isDragging()"
      [placeholderClasses]="true"
      [fields]="groupedColumns"
      [template]="dragAndDrop"
      [viewSource]="queryToken$ | async"
      [view]="view$ | async"
      [isMetrics]="false"
      [allowDiscrete]="true"
      [allowContinuous]="true"
      [allowScalars]="true"
      [chartType]="chartType"
      [dragField]="dragInfo"
      (dropField)="onDrop($event)"
      (dragStart)="onDragStart($event)"
      (dragEnd)="onDragEnd($event)"
      (fieldDropOnField)="onFieldDrop($event)"
    ></mode-encoding-dropzone>
  </div>
  <div class="zone">
    <mode-encoding-dropzone
      data-test="row-dropzone"
      [header]="'Rows (Y)'"
      [channel]="'row'"
      [isDraggable]="isDragging()"
      [placeholderClasses]="true"
      [fields]="groupedRows"
      [template]="dragAndDrop"
      [viewSource]="observables.queryToken$ | async"
      [view]="view$ | async"
      [isMetrics]="false"
      [allowDiscrete]="true"
      [allowContinuous]="true"
      [allowScalars]="true"
      [dragField]="dragInfo"
      [chartType]="chartType"
      (dropField)="onDrop($event)"
      (dragStart)="onDragStart($event)"
      (dragEnd)="onDragEnd($event)"
      (fieldDropOnField)="onFieldDrop($event)"
    ></mode-encoding-dropzone>
  </div>
  <div
    class="zone margin-top-medium measure-value-container"
    [class.is-showing]="hasMeasureValues"
    [class.full-height]="!isValuesEmpty()"
  >
    <mode-encoding-dropzone
      data-test="measure-values-dropzone"
      [header]="'Measure Values'"
      [channel]="'value'"
      [isDraggable]="isDragValidForValues"
      [placeholderClasses]="true"
      [fields]="encoding.value"
      [template]="dragAndDrop"
      [viewSource]="observables.queryToken$ | async"
      [view]="view$ | async"
      [isMetrics]="false"
      [dragField]="dragInfo"
      (dropField)="onDrop($event)"
      (dragStart)="onDragStart($event)"
      (dragEnd)="onDragEnd($event)"
      (fieldDropOnField)="onFieldDrop($event)"
      [isChartEncodingComplete]="isChartEncodingComplete"
      [allowDiscrete]="false"
      [allowContinuous]="true"
      [allowScalars]="false"
      [chartType]="chartType"
    ></mode-encoding-dropzone>
  </div>
</div>
